import React from 'react';

import { Button, Divider, Flex, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';

interface IProps {
  count: number;
  disabled: boolean;
  onSign: () => void;
}

export const RowsActions: React.FC<IProps> = ({ count, disabled, onSign }) => {
  const commonT = useTranslation(NSKeys.common);
  const epdT = useTranslation(NSKeys.epd);

  return (
    <Flex align="center" gap={8}>
      <Typography.Text>
        {count} {commonT.t('selected')}
      </Typography.Text>
      <Divider type="vertical" />
      <Button size="small" disabled={disabled} onClick={onSign}>
        {epdT.t('sign')}
      </Button>
    </Flex>
  );
};
